import React, { useState, useEffect } from 'react'
import { Link, useParams, useLocation, useNavigate } from 'react-router'
import { Heading, Text, Button, Alert, Progress, Box, Stack } from '@/components/lib'
import { api } from '../../api'
import useStore from '../../store'
import EntryContainer from '../includes/EntryContainer'
import utils from '../../utils/utils.js'

export default function OAuthLogin () {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { search } = useLocation()
  const { service } = useParams()
  const store = useStore()
  useEffect(() => {
    setError('')
    const params = new URLSearchParams(search)
    const oauthErr = params.get('error')
    if (oauthErr) {
      if (service) {
        window.sessionStorage.removeItem(utils.oauthLoginStateStorageKey(service))
      }
      setError('Sign-in was cancelled or could not be completed. Please try again.')
      return
    }
    const code = params.get('code')
    const state = params.get('state')
    const stateKey = utils.oauthLoginStateStorageKey(service)
    const expectedState = window.sessionStorage.getItem(stateKey)
    window.sessionStorage.removeItem(stateKey)
    if (!code || !service) {
      setError('There was a problem logging you in. Please try again.')
      return
    }
    if (!state || !expectedState || state !== expectedState) {
      setError('This sign-in session is invalid or has expired. Please return to the login page and try again.')
      return
    }
    setLoading(true)
    api.accounts.login({ service, code }, (data) => {
      setLoading(false)
      if (data.token) {
        store.completeLogin(data.token)
        navigate('/')
      }
    }, (err) => {
      setError(err.message)
      setLoading(false)
    })
  }, [search, service])

  return (
    <EntryContainer>
      <Box w='300px'>
        <Stack spacing={5}>
          <Heading size='lg'>Welcome!</Heading>

          <Text>Please stand by while we log you in...</Text>
          {loading && <Progress colorPalette='primary' value={null} />}

          {error &&
            <>
              <Alert status='error' variant='left-accent' flexDirection='column' alignItems='start'>
                <Heading size='sm' mb={2}>Sorry, we couldn't log you in</Heading>
                <Text>{error}</Text>
              </Alert>
              <Button mt={5} colorPalette='primary' as={Link} to='/'>Return to login page</Button>
            </>}
        </Stack>
      </Box>
    </EntryContainer>
  )
}
